export class ListControlViolationsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "controlViolations",
            "baseName": "controlViolations",
            "type": "Array<ControlViolation>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListControlViolationsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
